import { formatCurrency, getExplorer } from '@/utils';
import s from './styles.module.scss';
import { Flex, Text } from '@chakra-ui/react';
import { getUrlAvatarTwitter, shortCryptoAddress } from '@/utils/helpers';
import Avatar from '@/modules/AlphaPWA/Profiles/TradeKey/components/avatar';
import React, { useMemo, useRef, useState } from 'react';
import BigNumber from 'bignumber.js';
import { IcGoldBitcoin } from '@/layouts/AlphaLayout/CircleTreasury/TreasuryDetail/TreasuryAmount/svg/IcGoldBitcoin';
import { IcGoldToken } from '@/layouts/AlphaLayout/CircleTreasury/TreasuryDetail/TreasuryAmount/svg/IcGoldToken';
import ShowMoreByLines from '@/components/ShowMoreText';
import { useProfiles } from '@/modules/AlphaPWA/Profiles/provider';
import useClickOutside from '@/hooks/useHoverOutside';

type Props = {
  profile?: any;
  feeInfo?: any;
};

const TreasuryAmount = (props: Props) => {
  const { profile, feeInfo } = props;

  const [isShow, setIsShow] = useState(false);
  const refContent = useRef<HTMLDivElement>(null);
  useClickOutside(refContent, () => setIsShow(false));

  const usdTreasury = useMemo(() => {
    if (profile && feeInfo) {
      const btcBN = new BigNumber(feeInfo?.amountToken)
        .multipliedBy(profile.passTokenPrice || 0)
        .plus(feeInfo?.amountBTC);
      return new BigNumber(profile.btcPrice).multipliedBy(btcBN).toString();
    }
    return '0';
  }, [profile, feeInfo]);

  const usdBTC = useMemo(() => {
    if (profile && feeInfo) {
      const btcBN = new BigNumber(0).plus(feeInfo?.amountBTC);
      return new BigNumber(profile.btcPrice).multipliedBy(btcBN).toString();
    }
    return '0';
  }, [profile, feeInfo]);

  const usdToken = useMemo(() => {
    if (profile && feeInfo) {
      const btcBN = new BigNumber(feeInfo?.amountToken).multipliedBy(
        profile.passTokenPrice || 0
      );
      return new BigNumber(profile.btcPrice).multipliedBy(btcBN).toString();
    }
    return '0';
  }, [profile, feeInfo]);

  return (
    <div className={s.body}>
      <Flex
        flexDirection="row"
        justifyContent="flex-start"
        gap="8px"
        ml="16px"
        w="fit-content"
        mb="12px"
        onClick={() => setIsShow(pre => !pre)}
        ref={refContent}
      >
        <div className={s.thumbnail_wrapper}>
          <Avatar
            url={
              getUrlAvatarTwitter(
                profile?.twitterAvatar as string,
                'medium',
                Boolean(profile?.twitterAvatar)
              ) || ''
            }
            address={profile?.address || ''}
            width={48}
          />
        </div>
        <Flex flexDirection="column">
          <Text fontSize={'14px'} fontWeight={500} opacity={'70%'}>
            Treasury
          </Text>
          <p className={s.usdValue}>${formatCurrency(usdTreasury, 2, 2)}</p>
        </Flex>
      </Flex>
      {isShow && (
        <Flex
          direction={'column'}
          mb={'24px !important'}
          ml="16px"
          mr="16px"
          gap={4}
          className={s.user_metadata_topup}
        >
          <Flex justifyContent={'space-between'} className={s.balanceWrapper}>
            <Flex alignItems={'center'} gap={2}>
              <IcGoldBitcoin />
              <h5>Bitcoin</h5>
            </Flex>
            <Flex
              direction={'column'}
              justifyContent={'flex-end'}
              textAlign={'right'}
            >
              <p className={s.balance}>
                {formatCurrency(feeInfo?.amountBTC, 0, 6, 'BTC')} BTC
              </p>
              <h6>${formatCurrency(usdBTC, 2, 2)}</h6>
            </Flex>
          </Flex>
          <Flex justifyContent={'space-between'} className={s.balanceWrapper}>
            <Flex alignItems={'center'} gap={2}>
              <IcGoldToken />
              <h5>
                <span>{profile?.twitterName}</span> Token
              </h5>
            </Flex>
            <Flex
              direction={'column'}
              justifyContent={'flex-end'}
              textAlign={'right'}
            >
              <p className={s.balance}>
                {formatCurrency(feeInfo?.amountToken, 0, 2)}
              </p>
              <h6>${formatCurrency(usdToken, 2, 2)}</h6>
            </Flex>
          </Flex>
        </Flex>
      )}

      {/*<div className={s.desc}>
        <p className={s.descLine}>
          The circle treasury gains income from
          {showMore ? (
            <>
              {' '}
              <span>{profile.twitterName}</span> tribe activities such as token
              trading, red packets, games, lucky wheels, and more.{' '}
              <span>{profile.twitterName}</span> key holders will manage it
              through a DAO.
            </>
          ) : (
            <>
              <span onClick={() => setShowMore(true)}> ...more</span>
            </>
          )}
        </p>
      </div>*/}
    </div>
  );
};

export default TreasuryAmount;
